import { render, staticRenderFns } from "./AddVideosToWidgetModal.vue?vue&type=template&id=05737f1c&scoped=true&"
import script from "./AddVideosToWidgetModal.vue?vue&type=script&lang=js&"
export * from "./AddVideosToWidgetModal.vue?vue&type=script&lang=js&"
import style0 from "./AddVideosToWidgetModal.vue?vue&type=style&index=0&id=05737f1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05737f1c",
  null
  
)

export default component.exports